import React from "react";
import { Container } from "reactstrap";
//import ChatBar from "../../pages/Chat/ChatBar";
//import ChatWindow from "../../pages/Chat/ChatWindow";

const Footer = () => {
  // const [chatOpen, setChatOpen] = useState(false);

  /* const toggleChat = () => {
    setChatOpen(!chatOpen);
  };
*/
  return (
    <React.Fragment>
      <div className="mt-5">
      <footer className="footer">
        {/*      <div>
          <ChatBar onClick={toggleChat} />

          {/* Componente del chat que se muestra o no, dependiendo del estado 
          {chatOpen && <ChatWindow />}
  </div>*/}

        <Container style={{}} fluid={true}>
          <div className="text-sm-end d-none d-sm-block">
            <span className="mx-3 badge  bg-secondary "></span>
            <span style={{ fontSize: ".9rem" }}>
              {new Date().getFullYear()} © Cuidad Limpia by GrupoDa2
            </span>
          </div>
        </Container>
      </footer>
      </div>

    </React.Fragment>
  );
};

export default Footer;
